import useMetrics from "../../../hooks/useMetrics"
import { setStateType } from "../../../types/setStateType"
import { ICampaignData } from "../store/types/sponsoredProducts"
import { ICampaignDataColumns, ITargetColumns } from "../types/table"

export function calcTargetMetrics(campaignData: ICampaignData, target) {
  // useMetrics is a pure factory of helper functions, not a real React hook.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { calcLimitedCPC, calcTargetCPC } = useMetrics()

  if (!campaignData.settings || !campaignData.limitedCPC) {
    return target
  }

  const aovValue = target.aov?.value
  const targetCPC = calcTargetCPC({
    targetAcos: campaignData.targetAcos,
    orders: target.orders,
    impressions: target.impressions,

    aovValue: aovValue,
    clicks: target.clicks,
    bidInAmazon: target.bid,
    currentAcos: target.acos,
    sales: target.sales,
    defaultBid: campaignData.settings.defaultBid,
  })

  const limitedCPC = calcLimitedCPC({
    defaultBid: campaignData.settings.defaultBid,
    clicks: target.clicks,
    conditions: campaignData.limitedCPC.conditions,
    currentAcos: target.acos,
    targetAcos: campaignData.targetAcos,
    orders: target.orders,
    impressions: target.impressions,
    aovValue,
    bidInAmazon: target.bid,
    sales: target.sales,
    minTargetCPC: campaignData.settings.minTargetCPC,
    maxTargetCPC: campaignData.settings.maxTargetCPC,
  })

  return {
    ...target,
    targetCPC,
    limitedCPC,
  }
}

type EditableTargetField = "targetAcos" | "userDefinedLimitedCPC"

export function createTargetFieldHandler(
  field: EditableTargetField,
  setCampaigns: setStateType<ICampaignDataColumns[]>
) {
  return (event: React.ChangeEvent<HTMLInputElement>, target: ITargetColumns) => {
    const value = Number(event.target.value)

    setCampaigns((prev) =>
      prev.map((c) => ({
        ...c,
        targets: c.targets.map((t) =>
          t.targetId === target.targetId ? { ...t, [field]: value } : t
        ),
      }))
    )
  }
}
